module.exports = __webpack_public_path__ + "static/img/76-3.62c4764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/76-3.jpg
// module id = 6se4
// module chunks = 0